'use client';
import { deleteCookie } from '@/src/utils/cookie';
import { setChannel, setUser } from '@/src/v2/store/slices/user/UserSlice';
import dynamic from 'next/dynamic';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppDispatch } from '@/src/v2/hooks/useAppDispatch/UseAppDispatch';
import { getQueryClient } from '@/src/v2/service/graphql/api';
import { signOutService } from '@/src/services/auth';
import { useRouter } from 'next/navigation';
const LogoIconDynamic = dynamic(
  () => import('@/src/v2/assets/icons/LogoIcon'),
  {
    ssr: false,
  }
);
const ButtonDynamic = dynamic(
  () => import('@/src/v2/components/Button/Button'),
  {
    ssr: false,
  }
);
// Function to clear React Query cache
const clearCache = () => {
  const queryClient = getQueryClient(); // Create or access the query client instance
  queryClient.clear(); // Clear all cached queries
};

const RestrictAccount = () => {
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const router = useRouter();
  /*   const logout = async () => {
    const channel = new BroadcastChannel('app_channel');
    await signOutService(router);
    dispatchApp(setUser(null));
    dispatchApp(setChannel(null));
    channel.postMessage('user_logged_out');
    await router.push('/');
  }; */
  const logout = () => {
    const channel = new BroadcastChannel('app_channel');
    dispatch(setUser(null));
    dispatch(setChannel(null));
    localStorage.clear();
    deleteCookie('klic-email');
    deleteCookie('user');
    deleteCookie('ptoken');
    clearCache(); // Clear the cache
    channel.postMessage('user_logged_out');
    router.push('/');
  };

  return (
    <div
      className="vCenterFirst"
      style={{
        textAlign: 'center',
      }}
    >
      <div
        className="vCenter"
        style={{
          width: `100%`,
        }}
      >
        <LogoIconDynamic width={100} height={30} />
        <br></br>
        <h4>
          Your account has been deactivated by an administrator. Please reach
          out to our technical support for more details.
        </h4>
        <br></br>
        <ButtonDynamic
          label={`Logout`}
          type={'primary-v2'}
          onClick={() => logout()}
        />
      </div>
    </div>
  );
};

export default RestrictAccount;
